"use client";

export function FooterText() {
  const currentYear = new Date().getFullYear();
  const footerText = `© ${currentYear} Modity`;

  return <p>{footerText}</p>;
}
